export const GET_POSTS = "investments/GET_POSTS";
export const GET_POST = "investments/GET_POST";
export const UPDATE_POST = "investments/UPDATE_POST";
export const CLEAR_POSTS = "investments/CLEAR_POSTS";
export const UPDATE_POST_TO_FAVORITES = "investments/UPDATE_POST_TO_FAVORITES";
